import { render, staticRenderFns } from "./ManagerContractorDBIcon.vue?vue&type=template&id=48f564a4"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48f564a4')) {
      api.createRecord('48f564a4', component.options)
    } else {
      api.reload('48f564a4', component.options)
    }
    module.hot.accept("./ManagerContractorDBIcon.vue?vue&type=template&id=48f564a4", function () {
      api.rerender('48f564a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ManagerContractorDBIcon.vue"
export default component.exports